import ModalComponent from '@components/modal/Modal.component';
import {Button, CircularProgress, Stack, Typography} from '@mui/material';
import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {finalize} from 'rxjs';
import {auditsOfferService} from '@store/audits/audit-offer/audit-offer.services';

interface ActivateAuditModalProps {
  onClose: () => void;
}

const ActivateAuditModal = (props: ActivateAuditModalProps) => {
  const {onClose} = props;
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const {auditId} = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const handleActivate = () => {
    setIsLoading(true);
    auditsOfferService.ActivateOfferByAuditId(auditId as string).pipe(
      finalize(() => setIsLoading(false)),
    ).subscribe({
      next: () => {
        enqueueSnackbar(t('audits.success.offer.activate'), {variant: 'success'});
        onClose();
      },
      error: () => {
        enqueueSnackbar(t('errors.genericError'), {variant: 'error'});
      },
    });
  };

  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.OfferActivation.activateOffer.title')}
      handleClose={onClose}
      customColor="#FFFFFF"
      contentFullWidth
      content={(
        <Stack width="100%" height={'100%'} bgcolor="#F4F6F8" justifyContent="center" alignItems="center" spacing={5}
               padding={'30px'}>
          <Typography>{t('audits.OfferActivation.activateOffer.confirm')}</Typography>
          <Stack direction={'row'} spacing={3}>
            <Button variant="outlined" color="primary" disabled={isLoading} onClick={onClose}>
              {t('global.cancel')}
            </Button>
            <Button variant="contained" onClick={handleActivate} disabled={isLoading}>
              {isLoading ?
                <CircularProgress size={20} sx={{alignSelf: 'center', color: '#FFF'}}/> : t('global.activate')}
            </Button>
          </Stack>
        </Stack>
      )}
    />
  );
};

export default ActivateAuditModal;
